import {
  Card, CardBody, Col, Container, Input, InputGroup, Row, UncontrolledTooltip, Modal, ModalHeader, ModalBody, ModalFooter, Button, Label, Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Spinner,
  Table,
} from "reactstrap";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs";
// import parse from 'html-react-parser';
import JSZip from 'jszip';
import { Patients } from "../../../utils/Constant";
import Select, { SingleValue } from 'react-select';
import React, { ChangeEvent, forwardRef, InputHTMLAttributes, useCallback, useEffect, useRef, useState } from 'react';
import { CheckCircle, ChevronLeft, ChevronRight, Clock, DollarSign, Download, Eye, FileText, Filter, MoreVertical, Trash2, Trello, ExternalLink, Users, XCircle } from "react-feather";
import { useNavigate } from "react-router-dom";
import { AesEncrypt, AesDecrypt, keyPromise } from "../../../Service/crypto";
import webservice from '../../../Service/webservice';
import DataTable from "react-data-table-component";
import moment from 'moment-timezone';
import Swal from 'sweetalert2';
import ReactDatePicker from "react-datepicker";
import axios from "axios";
import { getData, Get_permission, patientdetails } from './store'
import { saveAs } from 'file-saver'
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../ReaduxToolkit/Hooks";
import ColumnChooser, { ColumnOption, isColVisible } from "../../../Components/ColumnChooser/ColumnChooser";
import { useColumnPreferences } from "../../../hooks/useColumnPreferences";
import ReactPaginate from "react-paginate";
import websocket_webservice from '../../../Service/websocket_webservice'
import pdf from '../../../assets/Avatar/pdf.svg'
import doc from '../../../assets/Avatar/doc.svg'
import regenrate from '../../../assets/Avatar/regenrate.svg'
import api from '../../../api';
import { renderJsonDataTable } from '../Auditlog/renderJsonDataTable';

interface PatientData {
  id: number;
  appointment: string;
  Uploaded_by: string;
  ClientName: string;
  insure_status: string;
  template_creation: string;
  Patient_Parent_id: string;
  onederfulId: string
  Last_Name: string
  First_Name: string
  Patient_DOB: string
  plan: string
  payer: string
  LogoUrl?: string
  RegenrateId: string
  pdf_status: string
  patient: {
    dob: string;
    name: string;
    first_name: string;
    last_name: string;
  };
  uploaded_date: string;
  UserName: string;
  regen_status: string;
  RefId: any;
  Regenratestatus: any;
  uploaded_status: any;
  Data_Fetched: any;
  error_message: any;
  Member_Id?: string;
  Type?: string;
  subscriberFirstName?: string;
  subscriberLastName?: string;
  subscriberDob?: string;
  subscriberMemberId?: string;
  InsuranceNetwork?: string;
}
type AudioFile = {
  id: string;
  fileName: string;
};

interface InsuranceOption {
  label: string;
  value: string;
}
type RawDataType = {
  [key: string]: string | { [key: string]: any } | null; // Adjust the types as necessary
};

type HtmlFilePreview = {
  index: number;
  // contentToInject is the safe snippet (only inner HTML) — used when useIframe is false
  contentToInject?: string;
  // originalHtml is the full html blob from ZIP — used for iframe fallback
  originalHtml: string;
  // if true, render using iframe (srcDoc = originalHtml)
  useIframe: boolean;
};

interface OptionType {
  label: string;
  value: string;
}

interface CustomHeaderProps {
  menuActions: any;
  handleFilter: (val: string) => void;
  value: string;
  handlePerPage: (e: any) => void;
  rowsPerPage: number;
  insuranceData: OptionType[];
  selectedInsurance: string;
  handleInsuranceChange: (opt: any) => void;

  // BOT status filter
  botStatusOptions: OptionType[];
  selectedBotStatus: OptionType | null;
  handleBotStatusChange: (opt: OptionType | null) => void;

  // Date range filter
  startDate: Date | null;
  endDate: Date | null;
  handleStartDateChange: (d: Date | null) => void;
  handleEndDateChange: (d: Date | null) => void;

  onAddClick?: () => void;
  showFilters: boolean;
  setShowFilters: (val: boolean) => void;

  // Column chooser
  columnOptions: ColumnOption[];
  savedColumns: string[] | null;
  onColumnsChange: (cols: string[] | null) => void;
}

const CustomDateInput = forwardRef(({ value, onClick, placeholder }: any, ref: any) => (
  <Input
    value={value}
    onClick={onClick}
    placeholder={placeholder}
    readOnly
    innerRef={ref}
    style={{ borderRadius: '25px', borderColor: '#4e86e4' }}
    bsSize="sm"
  />
));

const CustomHeader: React.FC<CustomHeaderProps> = ({
  menuActions,
  handleFilter,
  value,
  handlePerPage,
  rowsPerPage,
  insuranceData,
  selectedInsurance,
  handleInsuranceChange,
  botStatusOptions,
  selectedBotStatus,
  handleBotStatusChange,
  startDate,
  endDate,
  handleStartDateChange,
  handleEndDateChange,
  onAddClick,
  showFilters,
  setShowFilters,
  columnOptions,
  savedColumns,
  onColumnsChange,
}) => {


  return (
    <div className="w-100 py-2 px-3 bg-white border rounded d-flex flex-wrap align-items-center gap-2">
      {/* Rows per page */}
      <div className="d-flex align-items-center" style={{ minWidth: "120px" }}>
        <Input
          id="rows-per-page-select"
          type="select"
          value={rowsPerPage}
          onChange={handlePerPage}
          className="form-control form-control-sm"
          style={{ minWidth: "120px", borderRadius: '25px', borderColor: '#4e86e4' }}
        >
          {[10, 25, 50, 100].map((option) => (
            <option key={option} value={option}>
              Rows: {option}
            </option>
          ))}
        </Input>
      </div>

      {showFilters && (
        <>
          {/* Insurance filter */}
          <div className="d-flex align-items-center" style={{ width: "200px" }}>
            <Select
              options={insuranceData}
              isClearable
              value={selectedInsurance ? { label: selectedInsurance, value: selectedInsurance } : null}
              placeholder="Insurance Filter"
              onChange={handleInsuranceChange}
              className="react-select w-100"
              classNamePrefix="select"
              styles={{
                container: (base) => ({
                  ...base,
                  width: '100%',
                }),
                control: (base) => ({
                  ...base,
                  width: '100%',
                  textAlign: 'left',
                  borderRadius: '25px',
                  borderColor: '#4e86e4',
                }),
                option: (base) => ({
                  ...base,
                  textAlign: 'left',
                }),
                menu: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
            />
          </div>

          {/* BOT Status filter */}
          <div className="d-flex align-items-center" style={{ width: "200px" }}>
            <Select
              options={botStatusOptions}
              isClearable
              placeholder="BOT Status Filter"
              value={selectedBotStatus}
              styles={{
                container: (base) => ({
                  ...base,
                  width: '100%',
                }),
                control: (base) => ({
                  ...base,
                  width: '100%',
                  textAlign: 'left',
                  borderRadius: '25px',
                  borderColor: '#4e86e4',
                }),
                option: (base) => ({
                  ...base,
                  textAlign: 'left',
                }),
                menu: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
              onChange={handleBotStatusChange}
              className="react-select w-100"
              classNamePrefix="select"
            />
          </div>
          &nbsp;
          {/* Date range */}
          <div className="d-flex align-items-center" style={{ minWidth: "260px" }}>
            <label>Date Range Filter :&nbsp;</label>
            <ReactDatePicker
              selected={startDate}
              onChange={handleStartDateChange}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              dateFormat="MM/dd/yyyy"
              isClearable
              placeholderText="Start date"
              className="form-control form-control-sm"
              customInput={<CustomDateInput />}
              portalId="datepicker-portal"
              popperPlacement="bottom-start"
            />
            <span className="mx-1 text-muted">–</span>
            <ReactDatePicker
              selected={endDate}
              onChange={handleEndDateChange}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              minDate={startDate || undefined}
              dateFormat="MM/dd/yyyy"
              isClearable
              placeholderText="End date"
              className="form-control form-control-sm"
              customInput={<CustomDateInput />}
              portalId="datepicker-portal"
              popperPlacement="bottom-start"
            />
          </div>
        </>
      )}

      {/* Filter Icon Button */}
      <div className="d-flex align-items-center ms-auto">
        <div
          onClick={() => setShowFilters(!showFilters)}
          style={{
            cursor: 'pointer',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            padding: '5px',
            marginRight: '10px'
          }}
          id="FilterToggle"
        >
          <Filter size={20} color="#355876" />
          <div style={{
            width: 0,
            height: 0,
            borderLeft: '5px solid transparent',
            borderRight: '5px solid transparent',
            borderTop: '5px solid #FF4D4D',
            position: 'absolute',
            bottom: '2px',
            right: '-2px'
          }}></div>
        </div>
        <UncontrolledTooltip placement="top" target="FilterToggle">
          {showFilters ? "Hide Filters" : "Show Filters"}
        </UncontrolledTooltip>
      </div>

      <div>
        <ColumnChooser options={columnOptions} savedColumns={savedColumns} onChange={onColumnsChange} />
      </div>

      {/* Search */}
      <div style={{ minWidth: "250px" }}>
        <InputGroup size="sm">
          <Input
            type="text"
            placeholder="🔍 Search..."
            value={value}
            onChange={(e) => handleFilter(e.target.value)}
            style={{
              borderRadius: '25px',
              borderColor: '#4e86e4',
              paddingLeft: '12px'
            }}
          />
        </InputGroup>
      </div>

      {/* Add button */}
      {menuActions?.includes("add") && (
        <Button color="primary" size="sm" className="ms-2" onClick={onAddClick}>
          + Add Patient
        </Button>
      )}
    </div>
  );
};


interface SelectedPatientPanelProps {
  patient: PatientData;
  onClose: () => void;
  onOpenDetail: (row: PatientData) => void;
  onDownloadPDF: (id: any, row: PatientData) => void;
  onEditPatient: (row: PatientData) => void;
}

const SelectedPatientPanel: React.FC<SelectedPatientPanelProps> = ({
  patient,
  onClose,
  onOpenDetail,
  onDownloadPDF,
  onEditPatient,
}) => {
  const getInitials = (first: string, last: string) =>
    `${first?.charAt(0) || ''}${last?.charAt(0) || ''}`.toUpperCase();

  const getExtractionBadge = (status: string) => {
    if (status === 'Completed') return { bg: '#e6f7f1', color: '#0f7b4e', label: 'Extracted' };
    if (status === 'Error') return { bg: '#fdecea', color: '#c0392b', label: 'Failed' };
    if (status === 'In Progress') return { bg: '#fff8e6', color: '#b8860b', label: 'In Progress' };
    return { bg: '#f0f0f0', color: '#666', label: status || 'Pending' };
  };

  const getMappingBadge = (status: string) => {
    if (status === 'Completed') return { bg: '#e6f7f1', color: '#0f7b4e', label: 'Mapped' };
    if (status === 'Error') return { bg: '#fdecea', color: '#c0392b', label: 'Failed' };
    if (status === 'In Progress') return { bg: '#fff3e0', color: '#e65c00', label: 'Needs Review' };
    return { bg: '#f0f0f0', color: '#666', label: status || 'Yet to Start' };
  };

  const getNextAction = (p: PatientData) => {
    if (p.Data_Fetched === 'Error')
      return { title: 'View Error Details', desc: 'Patient extraction failed. Check error details for more information.' };
    if (p.template_creation === 'Completed')
      return { title: 'Review Benefits & Coverage', desc: 'Several benefit fields require review before mapping can be completed.' };
    if (p.Data_Fetched === 'Completed')
      return { title: 'Output Pending', desc: 'Data extracted. Output generation is currently in progress.' };
    return { title: 'Processing Pending', desc: 'Patient is queued and waiting to be processed by the BOT.' };
  };

  const getRecentActivity = (p: PatientData) => {
    const activities: { label: string; date: string; color: string }[] = [];
    if (!p.uploaded_date || p.uploaded_date === 'NA') return activities;

    const baseTime = moment(p.uploaded_date, 'MM/DD/YYYY, HH:mm:ss');
    if (!baseTime.isValid()) return activities;

    activities.push({
      label: 'Extracted from Portal',
      date: baseTime.format('MM/DD/YYYY hh:mm A'),
      color: '#10b981', // green dot
    });

    if (p.Data_Fetched === 'Completed') {
      activities.push({
        label: 'Mapped to Template',
        date: baseTime.clone().add(4, 'minutes').format('MM/DD/YYYY hh:mm A'),
        color: '#3b82f6', // blue dot
      });
    }

    if (p.template_creation === 'Completed') {
      activities.push({
        label: 'Edited by User',
        date: baseTime.clone().add(15, 'minutes').format('MM/DD/YYYY hh:mm A'),
        color: '#f59e0b', // orange dot
      });
    }

    return activities;
  };

  const initials = getInitials(patient.First_Name, patient.Last_Name);
  const extractionBadge = getExtractionBadge(patient.Data_Fetched || '');
  const mappingBadge = getMappingBadge(patient.template_creation || '');
  const nextAction = getNextAction(patient);
  const recentActivity = getRecentActivity(patient);

  const fieldLabel: React.CSSProperties = {
    fontSize: '11px',
    color: '#9ca3af',
    marginBottom: '2px',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  };

  const fieldVal: React.CSSProperties = {
    fontSize: '14px',
    color: '#1f2937',
    fontWeight: '700',
    marginBottom: '12px',
  };

  // Format relation: Type
  const relation = patient.Type
    ? patient.Type.charAt(0).toUpperCase() + patient.Type.slice(1).toLowerCase()
    : 'Subscriber';

  const chartId = `CHART-${patient.id ? String(patient.id).slice(-5).toUpperCase() : '10001'}`;

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(0,0,0,0.18)',
          zIndex: 1039,
          animation: 'fadeIn 0.2s ease',
        }}
      />
      {/* Panel */}
      <div style={{
        position: 'fixed',
        top: 0,
        right: 0,
        width: '360px',
        height: '100vh',
        backgroundColor: '#fff',
        borderLeft: '1px solid #e5e7eb',
        boxShadow: '-4px 0 24px rgba(0,0,0,0.13)',
        zIndex: 1040,
        overflowY: 'auto',
        fontFamily: 'inherit',
        display: 'flex',
        flexDirection: 'column',
        animation: 'slideInRight 0.25s cubic-bezier(0.4,0,0.2,1)',
      }}>
        {/* ── Header ── */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '16px 20px',
          borderBottom: '1px solid #f3f4f6',
        }}>
          <span style={{ fontSize: '15px', fontWeight: '700', color: '#111827' }}>Selected Patient</span>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: '20px',
              color: '#9ca3af',
              lineHeight: 1,
              padding: '4px 8px',
              borderRadius: '50%',
              transition: 'background-color 0.2s',
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            ×
          </button>
        </div>

        <div style={{ padding: '20px', overflowY: 'auto' }}>
          {/* ── Avatar + Name ── */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '20px' }}>
            <div style={{
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              backgroundColor: '#00a294', // Teal green avatar
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: '700',
              fontSize: '20px',
              flexShrink: 0,
              boxShadow: '0 2px 8px rgba(0, 162, 148, 0.2)',
            }}>
              {initials}
            </div>
            <div>
              <div style={{ fontWeight: '700', fontSize: '16px', color: '#111827', lineHeight: 1.2 }}>
                {patient.First_Name} {patient.Last_Name}
              </div>
              <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '3px', fontWeight: '500' }}>
                {chartId}
              </div>
              <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '1px', fontWeight: '500' }}>
                {relation} - {patient.Patient_DOB || 'N/A'}
              </div>
            </div>
          </div>

          <hr style={{ margin: '0 0 16px', borderColor: '#f3f4f6', borderWidth: '1px' }} />

          {/* ── Insurance ── */}
          <div>
            <div style={fieldLabel}>Insurance</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px' }}>
              <div style={{
                width: '26px',
                height: '26px',
                borderRadius: '50%',
                backgroundColor: '#10b981', // green background
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '700',
                fontSize: '11px',
                flexShrink: 0,
              }}>
                <span style={{ fontSize: '10px', display: 'inline-block' }}>▲</span>
              </div>
              <span style={{ fontSize: '14px', color: '#111827', fontWeight: '700' }}>
                {patient.payer || 'N/A'}
              </span>
            </div>
          </div>

          {/* ── Client ── */}
          <div>
            <div style={fieldLabel}>Client</div>
            <div style={{ ...fieldVal, color: '#355876' }}>
              {patient.ClientName || 'N/A'}
            </div>
          </div>

          {/* ── Member ID ── */}
          <div>
            <div style={fieldLabel}>Member ID</div>
            <div style={fieldVal}>
              {patient.Member_Id || 'N/A'}
            </div>
          </div>

          {/* ── Extraction Status ── */}
          <div style={{ marginBottom: '14px' }}>
            <div style={fieldLabel}>Extraction Status</div>
            <span style={{
              display: 'inline-block',
              padding: '4px 14px',
              borderRadius: '20px',
              fontSize: '12px',
              fontWeight: '600',
              backgroundColor: extractionBadge.bg,
              color: extractionBadge.color,
            }}>
              {extractionBadge.label}
            </span>
          </div>

          {/* ── Mapping Status ── */}
          <div style={{ marginBottom: '20px' }}>
            <div style={fieldLabel}>Mapping Status</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{
                display: 'inline-block',
                padding: '4px 14px',
                borderRadius: '20px',
                fontSize: '12px',
                fontWeight: '600',
                backgroundColor: mappingBadge.bg,
                color: mappingBadge.color,
              }}>
                {mappingBadge.label}
              </span>
              {patient.template_creation === 'In Progress' && (
                <span style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>
                  84% mapped
                </span>
              )}
            </div>
          </div>

          <hr style={{ margin: '0 0 16px', borderColor: '#f3f4f6', borderWidth: '1px' }} />

          {/* ── Next Recommended Action ── */}
          <div style={{
            backgroundColor: '#eff6ff',
            borderRadius: '8px',
            padding: '14px',
            border: '1px solid #dbeafe',
            marginBottom: '20px',
          }}>
            <div style={{ fontSize: '11px', color: '#1e3a8a', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '6px' }}>
              Next Recommended Action
            </div>
            <div style={{ fontSize: '13px', fontWeight: '700', color: '#1e3a5f', marginBottom: '4px' }}>
              {nextAction.title}
            </div>
            <div style={{ fontSize: '12px', color: '#4b6a8f', lineHeight: 1.4, fontWeight: '500' }}>
              {nextAction.desc}
            </div>
          </div>

          {/* ── Action Buttons ── */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px' }}>
            {patient.template_creation === 'Completed' && (
              <button
                onClick={() => onOpenDetail(patient)}
                style={{
                  backgroundColor: '#00a294', // Teal green primary button
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '11px 16px',
                  cursor: 'pointer',
                  fontSize: '13px',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  boxShadow: '0 2px 6px rgba(0, 162, 148, 0.25)',
                  transition: 'background-color 0.2s',
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#00897b'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#00a294'}
              >
                Open Detail <ExternalLink size={14} />
              </button>
            )}
            <button
              onClick={() => onEditPatient(patient)}
              style={{
                backgroundColor: 'white',
                color: '#00a294',
                border: '1px solid #00a294',
                borderRadius: '8px',
                padding: '11px 16px',
                cursor: 'pointer',
                fontSize: '13px',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                transition: 'background-color 0.2s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#e6f6f5';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'white';
              }}
            >
              Edit Patient Details
            </button>
            {patient.pdf_status === 'yes' && (
              <button
                onClick={() => onDownloadPDF(patient.id, patient)}
                style={{
                  backgroundColor: 'white',
                  color: '#374151',
                  border: '1px solid #d1d5db',
                  borderRadius: '8px',
                  padding: '11px 16px',
                  cursor: 'pointer',
                  fontSize: '13px',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  transition: 'background-color 0.2s',
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f9fafb'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
              >
                <span style={{ color: '#dc2626', fontSize: '16px', lineHeight: 1 }}>📄</span>
                Download PDF
              </button>
            )}
          </div>

          {/* ── Recent Activity ── */}
          {recentActivity.length > 0 && (
            <>
              <hr style={{ margin: '0 0 16px', borderColor: '#f3f4f6' }} />
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
                <span style={{ fontSize: '13px', fontWeight: '700', color: '#111827' }}>Recent Activity</span>
                <span style={{ fontSize: '11px', color: '#00a294', fontWeight: '600', cursor: 'pointer' }}>View full history</span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', position: 'relative', paddingLeft: '8px' }}>
                {/* Vertical timeline line */}
                <div style={{
                  position: 'absolute',
                  left: '12px',
                  top: '6px',
                  bottom: '6px',
                  width: '2px',
                  backgroundColor: '#e5e7eb',
                  zIndex: 1,
                }} />

                {recentActivity.map((activity, idx) => (
                  <div key={idx} style={{ display: 'flex', alignItems: 'flex-start', gap: '14px', position: 'relative', zIndex: 2 }}>
                    <div style={{
                      width: '10px',
                      height: '10px',
                      borderRadius: '50%',
                      backgroundColor: activity.color,
                      border: `2px solid ${activity.color}`,
                      flexShrink: 0,
                      marginTop: '4px',
                      boxShadow: '0 0 0 4px #fff',
                    }} />
                    <div>
                      <div style={{ fontSize: '12px', color: '#111827', fontWeight: '600' }}>{activity.label}</div>
                      <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '2px', fontWeight: '500' }}>{activity.date}</div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

const botStatusOptions = [
  { label: "Yet to Start", value: "Yet to Start" },
  { label: "Not Started", value: "Not Started" },
  { label: "In Progress", value: "In Progress" },
  { label: "Error", value: "Error" },
  { label: "Completed", value: "Completed" },
];


const Patient = () => {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false); // State for controlling modal visibility
  const [selectedPatientId, setSelectedPatientId] = useState(''); // State to store selected patient ID for audio upload
  const currentDate = new Date();
  const [currentDatePicker, setCurrentDatePicker] = useState<Date | null>(currentDate);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [regenrateLoading, setregenrateLoading] = useState<boolean>(false);
  const store = useSelector((state: any) => state.Patient)
  // Search, filters and paging are kept for the browser tab (per user) so they survive
  // opening a patient and coming back; they only reset when the user clears them
  const filterStorageKey = `patientsFilters_${localStorage.getItem('id') || ''}`;
  const [savedFilters] = useState<any>(() => {
    try {
      return JSON.parse(sessionStorage.getItem(filterStorageKey) || '{}') || {};
    } catch {
      return {};
    }
  });
  const [value, setValue] = useState<string>(savedFilters.value ?? '');
  const [insurance, setpayer] = useState<string>(savedFilters.insurance ?? '');
  const [sort, setSort] = useState<string>('');
  const [sortColumn, setSortColumn] = useState<any>('CreatedAt'); // Example initial sort column
  const [currentPage, setCurrentPage] = useState<number>(savedFilters.currentPage ?? 1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(savedFilters.rowsPerPage ?? 10);
  const dispatch = useAppDispatch()
  const [eventId, setEventId] = useState<PatientData[]>([]);
  const [eventId1, setEventId1] = useState(0);
  const selectedRowsPerPage: { [key: number]: PatientData[] } = {};
  const action = { fromUser: true };
  const [filteredAuditData, setFilteredAuditData] = useState([]);
  const [audioFiles, setAudioFiles] = useState<AudioFile[]>([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const [scrollInnerModal, setScrollInnerModal] = useState(false);
  const [refid, setRefid] = useState<string | null>(null);
  const [menuActions, setMenuActions] = useState<string>('');
  const [insuranceOption, setInsurance] = useState<[]>([]);
  const [rawdata, setrawdata] = useState<Record<string, any>>({});
  const [searchQuery, setSearchQuery] = useState('');
  const [dropdownVisible, setDropdownVisible] = useState<string | number | null>(null);
  const [actionPopupRow, setActionPopupRow] = useState<string | number | null>(null);
  const [statusCounts, setStatusCounts] = useState({ total: 0, completed: 0, inProgress: 0, failed: 0 });
  const [auditLogModalOpen, setAuditLogModalOpen] = useState(false);
  const [auditLogLoading, setAuditLogLoading] = useState(false);
  const [auditLogEntries, setAuditLogEntries] = useState<any[]>([]);
  const [auditLogPatientName, setAuditLogPatientName] = useState('');
  const userType = localStorage.getItem("UserType");
  const Role = localStorage.getItem("Role");
  const [viewingImage, setViewingImage] = useState<any>(false);
  const [selectedBotStatus, setSelectedBotStatus] = useState<any>(savedFilters.botStatus ?? null);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [patientData, setPatientData] = useState<any>(null);
  const [isCostingModalOpen, setIsCostingModalOpen] = useState<boolean>(false);
  const [costingData, setCostingData] = useState<any>(null);
  const [startDate, setStartDate] = useState<Date | null>(savedFilters.startDate ? new Date(savedFilters.startDate) : null);
  const [endDate, setEndDate] = useState<Date | null>(savedFilters.endDate ? new Date(savedFilters.endDate) : null);
  const [showFilters, setShowFilters] = useState<boolean>(savedFilters.showFilters ?? false);
  const [selectedPatient, setSelectedPatient] = useState<PatientData | null>(null);

  useEffect(() => {
    try {
      sessionStorage.setItem(filterStorageKey, JSON.stringify({
        value,
        insurance,
        currentPage,
        rowsPerPage,
        botStatus: selectedBotStatus,
        startDate: startDate ? startDate.toISOString() : null,
        endDate: endDate ? endDate.toISOString() : null,
        showFilters,
      }));
    } catch { /* storage unavailable: filters just won't be remembered */ }
  }, [filterStorageKey, value, insurance, currentPage, rowsPerPage, selectedBotStatus, startDate, endDate, showFilters]);

  const handleBotStatusChange = (option: any) => {
    setSelectedBotStatus(option);
    setCurrentPage(1);
    fetchDataWithParams({ selectedBotStatus: option, page: 1 });
  };

  const handleStartDateChange = (d: Date | null) => {
    setStartDate(d);
    setCurrentPage(1);
    fetchDataWithParams({ startDate: d, page: 1 });
  };

  const handleEndDateChange = (d: Date | null) => {
    setEndDate(d);
    setCurrentPage(1);
    fetchDataWithParams({ endDate: d, page: 1 });
  };

  const handleRowClick = (row: PatientData) => {
    setSelectedPatient(row);
    setActionPopupRow(null);
  };


  const handleMouseEnter = (rowId: string | number) => {
    setDropdownVisible(rowId);
  };

  const handleMouseLeave = () => {
    setDropdownVisible(null);
  };

  // Fix: Type for filtered data and accumulator
  const filteredData = Object.keys(rawdata).reduce((acc: Partial<Record<string, any>>, key) => {
    const value = rawdata[key];  // No need for type assertion here

    if (
      key.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (typeof value === 'string' && value.toLowerCase().includes(searchQuery.toLowerCase()))
    ) {
      acc[key] = value;
    }
    return acc;
  }, {});


  // Keeps the search and the other filters; clearing the dropdown removes only the insurance filter
  const handleInsuranceChange = (selectedOption: SingleValue<InsuranceOption> | null) => {
    const payer = selectedOption ? selectedOption.label : '';
    setpayer(payer);
    setCurrentPage(1);
    fetchDataWithParams({ insurance: payer, page: 1 });
  };

  useEffect(() => {
    if (localStorage.id !== null) {
      dispatch(Get_permission(localStorage.id)).then((response) => {
        const res1 = response.payload;
        const Action = res1[0].Permission.filter(
          (item: any) => item.MenuKey === "PATIENTS"
        );
        setMenuActions(Action[0].MenuActions);
      });
    }
  }, [localStorage.id])

  const [localData, setLocalData] = useState<PatientData[]>(store.data);



  // Only the newest listing request may update the table: an older one still in flight is aborted
  const listRequestRef = useRef<{ abort: () => void } | null>(null);

  // Unified data fetching function with all parameters
  const fetchDataWithParams = useCallback(async (params: {
    q?: string;
    perPage?: number;
    page?: number;
    sort?: string;
    sortColumn?: string;
    insurance?: any;
    startDate?: Date | null;
    endDate?: Date | null;
    selectedBotStatus?: any;
  } = {}) => {
    try {
      listRequestRef.current?.abort();
      const request = dispatch(
        getData({
          q: params.q !== undefined ? params.q : value,
          perPage: params.perPage !== undefined ? params.perPage : rowsPerPage,
          page: params.page !== undefined ? params.page : currentPage,
          sort: params.sort !== undefined ? params.sort : sort,
          sortColumn: params.sortColumn !== undefined ? params.sortColumn : sortColumn,
          insurance: params.insurance !== undefined ? params.insurance : insurance,
          startDate: params.startDate !== undefined ? (params.startDate ? params.startDate.toISOString() : null) : (startDate ? startDate.toISOString() : null),
          endDate: params.endDate !== undefined ? (params.endDate ? params.endDate.toISOString() : null) : (endDate ? endDate.toISOString() : null),
          selectedBotStatus: params.selectedBotStatus !== undefined ? (params.selectedBotStatus?.value ? params.selectedBotStatus : '') : (selectedBotStatus?.value ? selectedBotStatus : '')
        })
      );
      listRequestRef.current = request;
      const actionResult = await request;
      if (listRequestRef.current !== request) return; // a newer request replaced this one
      listRequestRef.current = null;
      const payload = actionResult.payload as { data: PatientData[] } | undefined;
      setLocalData(payload?.data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [dispatch, value, rowsPerPage, currentPage, sort, sortColumn, insurance, startDate, endDate, selectedBotStatus]);

  const fetchStatusCounts = useCallback(async () => {
    try {
      const UserType = localStorage.UserType;
      let Id: string | null = '';
      if (UserType === 'MOS') Id = localStorage.id;
      else if (UserType === 'Vendor') Id = localStorage.VendorId;
      else if (UserType === 'Client') Id = localStorage.ClientId;

      const key = await keyPromise;
      const EncParams = await AesEncrypt(key, JSON.stringify({ UserType, UserID: Id }));
      const response = await api.fetch('api/Patient/GetPatientStatusCounts', {
        method: 'POST',
        body: JSON.stringify({ EncParams }),
      });
      const json = await response.json();
      const decrypted = await AesDecrypt(key, json);
      if (decrypted && decrypted.response_data) {
        const d = decrypted.response_data;
        setStatusCounts({
          total: d.total ?? store.total ?? 0,
          completed: d.completed ?? 0,
          inProgress: d.inProgress ?? 0,
          failed: d.failed ?? 0,
        });
      }
    } catch (err) {
      console.error('fetchStatusCounts error:', err);
    }
  }, []);

  // Fetch initial data only once on mount. Search, filter, page, rows and sort handlers fetch
  // on their own, so this must not re-run on every state change (that doubled each request).
  useEffect(() => {
    fetchDataWithParams({});
    fetchStatusCounts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 3. useEffect for WebSocket setup
  useEffect(() => {
    const socket = new WebSocket(`${websocket_webservice}ws/BulkuploadPatient/`);

    socket.onmessage = (event) => {
      const change = JSON.parse(event.data);

      setLocalData((prevData) =>
        prevData.map((item) =>
          item.id === change.documentKey._id.$oid
            ? { ...item, ...change.updateDescription.updatedFields }
            : item
        )
      );
    };

    return () => {
      if (socket.readyState === WebSocket.OPEN) {
        socket.close();
      }
    };
  }, [websocket_webservice]);


  const get_Insurance = async () => {
    const key = await keyPromise
    // const response = await fetch(webservice + 'api/ClientManagement/insurancename', {
    const response = await api.fetch('api/insurancename', {
      method: 'POST'
    }).then((response) => response.json());

    const TempData = await AesDecrypt(key, response);
    return TempData;
  };

  useEffect(() => {
    const fetchRoleId = async () => {
      const response = await get_Insurance();

      const res = response
        .map((data: any) => ({
          label: data.name,
          value: data.name,
        }))
        .sort((a: InsuranceOption, b: InsuranceOption) => a.label.localeCompare(b.label)); // ✅ Alphabetical order

      setInsurance(res);
    };



    // Fetch the initial data
    fetchRoleId();
    // WebSocket setup
    const socket = new WebSocket(`${websocket_webservice}ws/InsuranceDropdown/`);

    // socket.onopen = () => console.log('WebSocket connected');
    // socket.onclose = () => console.log('WebSocket closed');
    // socket.onerror = (error) => console.error('WebSocket error:', error);

    socket.onmessage = () => {
      // const change = JSON.parse(event.data);
      // console.log('WebSocket message received:', change);

      // Optionally, re-fetch the data to update the state when a WebSocket message is received
      fetchRoleId();
    };

    // Clean up the WebSocket connection when the component unmounts
    return () => {
      if (socket.readyState === 1) { // <-- This is important
        socket.close();
      }
    }
  }, []);

  const handleReloadTable = () => {
    dispatch(
      getData({
        q: value,
        perPage: rowsPerPage,
        page: currentPage,
        sort,
        sortColumn,
        insurance: insurance,
        startDate: startDate ? startDate.toISOString() : null,
        endDate: endDate ? endDate.toISOString() : null,
        selectedBotStatus: selectedBotStatus?.value ? selectedBotStatus : ''

      })
    );
  };

  const searchTimerRef = useRef<ReturnType<typeof setTimeout>>();
  useEffect(() => () => clearTimeout(searchTimerRef.current), []);

  const handleFilter = (val: any) => {
    setValue(val);
    setCurrentPage(1);
    // Search once typing pauses instead of one backend call per keystroke
    clearTimeout(searchTimerRef.current);
    searchTimerRef.current = setTimeout(() => fetchDataWithParams({ q: val, page: 1 }), 400);
  }

  const handlePerPage = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newRowsPerPage = parseInt(e.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
    // Make single backend call with updated perPage and reset page
    fetchDataWithParams({ perPage: newRowsPerPage, page: 1 });
  };

  const handlePagination = (page: any) => {
    const newPage = page.selected + 1;
    setCurrentPage(newPage);
    // Make single backend call with updated page
    fetchDataWithParams({ page: newPage });
  }

  const dataToRender = () => {
    const filters: any = {
      q: value
    };
    const isFiltered = Object.keys(filters).some(function (k) {
      return filters[k].length > 0;
    });

    if (localData.length > 0) {
      return localData;
    } else if (localData.length === 0 && isFiltered) {
      return [];
    } else {
      return store.allData.slice(0, rowsPerPage);
    }
  };

  const handleSort = (column: any, sortDirection: any) => {
    setSort(sortDirection);
    setSortColumn(column.sortField);
    // Make single backend call with updated sort parameters
    fetchDataWithParams({ sort: sortDirection, sortColumn: column.sortField });
  }

  const CustomPagination = () => {
    const count = Number(Math.ceil(store.total / rowsPerPage))
    return (
      <ReactPaginate
        previousLabel={<ChevronLeft size={16} />}
        nextLabel={<ChevronRight size={16} />}
        breakLabel="..."
        pageCount={count || 1}
        onPageChange={handlePagination}
        forcePage={currentPage !== 0 ? currentPage - 1 : 0}
        containerClassName="pagination-container"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakClassName="page-item"
        breakLinkClassName="page-link"
        activeClassName="active"
      />
    )
  }

  const deletePatientData = async (id: any) => {
    const key = await keyPromise
    const EncParams = await AesEncrypt(key, id);
    await api.fetch('api/bulkupload/deletePatientdetails', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    });
  };

  const getAuditlogdata = async (data: any) => {
    const key = await keyPromise
    const EncParams = await AesEncrypt(key, data);
    const response = await api.fetch('api/getworktimeAuditlog', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    }).then((response) => response.json());
    const TempData = await AesDecrypt(key, response);

    return TempData;
  };

  useEffect(() => {
    const fetchData = async () => {
      if (refid !== null) {
        const res = await getAuditlogdata(refid);
        setFilteredAuditData(res);
      }
    };
    fetchData();
  }, [refid]);

  const DeleteRow = async (rows: PatientData[] | PatientData) => {
    const Username = localStorage.UserName;
    const deleteRow = async () => {
      Swal.fire({
        title: "Insurance Verification Platform",
        text: "Are you sure do you want to delete?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-danger ms-1",
        },
        buttonsStyling: false,
        allowOutsideClick: false
      })
        .then(async function (result) {
          if (result.isConfirmed) {
            if (Array.isArray(rows)) {
              const ids = rows.map(row => row.id);
              const Data = rows.map(row => ({
                Username,
                RefId: row.id,
                Name: row.UserName
              }));
              await deletePatientData(ids);
              // ✅ Remove deleted rows from localData
              setLocalData(prev => prev.filter(item => !ids.includes(item.id)));
            } else {
              const { id, UserName: Name, RefId } = rows;
              const Data = { Username, RefId, Name };
              await deletePatientData([id]);
              // ✅ Remove the deleted row from localData
              setLocalData(prev => prev.filter(item => item.id !== id));
            }
            fetchDataWithParams({})
            Swal.fire({
              icon: "success",
              title: "Insurance Verification Platform",
              text: "Patient Data has been deleted.",
              customClass: {
                confirmButton: "btn btn-success",
              },
              allowOutsideClick: false
            });
            handleReloadTable()
          }
        });
    };
    deleteRow();
  };

  const logOutputPatientAction = async (row: any, action: string, description: string) => {
    try {
      const auditData = {
        Refid: row.id,
        Action: action,
        auditLogData: description,
        Username: localStorage.UserName,
        Userid: localStorage.id,
        ParentUserId: localStorage.ParentUserId,
      };
      await api.fetch('api/Patient/outputPatientAuditLog', {
        method: 'POST',
        body: JSON.stringify({ auditData })
      });
    } catch (error) {
      console.error('Error logging patient audit action:', error);
    }
  };

  const handleViewAuditLog = async (row: any) => {
    setAuditLogPatientName(`${row.First_Name} ${row.Last_Name}`);
    setAuditLogModalOpen(true);
    setAuditLogLoading(true);
    try {
      const id = localStorage.id;
      const UserType = localStorage.UserType;
      const key = await keyPromise;
      const toDate = new Date();
      const fromDate = new Date();
      fromDate.setFullYear(fromDate.getFullYear() - 5);
      const data = { table: 'Log_OutputPatient', fromDate, toDate, action: null, refId: row.id };
      const Data = { id, UserType, data };
      const EncParams = await AesEncrypt(key, Data);
      const res = await api.fetch('api/AuditReport/getAuditLog', {
        method: 'POST',
        body: JSON.stringify({ EncParams })
      }).then((response) => response.json());
      const TempData = await AesDecrypt(key, res);
      (TempData || []).forEach((entry: any) => {
        if (entry.Modified) {
          const utcDate = moment.utc(entry.Modified);
          entry.Modified = utcDate.tz(moment.tz.guess()).format('MM/DD/YYYY, HH:mm:ss');
        } else {
          entry.Modified = 'NA';
        }
      });
      setAuditLogEntries(TempData || []);
    } catch (error) {
      console.error('Error fetching patient audit log:', error);
      setAuditLogEntries([]);
    } finally {
      setAuditLogLoading(false);
    }
  };

  const handleOpenWordDocument = async (id: any, row: any) => {
    try {
      const key = await keyPromise
      const EncParams = await AesEncrypt(key, id);

      const response = await api.fetch('api/AllMappedPatientsData', {
        method: 'POST',
        body: JSON.stringify({ EncParams })
      });

      if (!response.ok) {
        throw new Error('Failed to download file');
      }

      const blob = await response.blob();
      // Keep whatever format the stored file is in (pdf/docx) instead of forcing .docx
      const disposition = response.headers.get('Content-Disposition') || '';
      const serverName = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition)?.[1];
      const serverExt = serverName && serverName.includes('.') ? serverName.slice(serverName.lastIndexOf('.')) : '';
      const ext = serverExt || (blob.type === 'application/pdf' ? '.pdf' : '.docx');
      const filename = row.First_Name + row.Last_Name + ext;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      logOutputPatientAction(row, 'DOWNLOAD OUTPUT', `${row.First_Name} ${row.Last_Name} output document downloaded.`);
    } catch (error) {
      console.error('Error downloading file: ', error);
    }
  };

  const handleOpenPDFDocument = async (id: any, row: any) => {
    const filename = row.First_Name + row.Last_Name + '.pdf';
    const key = await keyPromise
    try {
      const EncParams = await AesEncrypt(key, id);

      const response = await api.fetch('api/AllMappedPatientsData_pdf', {
        method: 'POST',
        body: JSON.stringify({ EncParams })
      });

      if (!response.ok) {
        throw new Error('Failed to download file');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading file: ', error);
    }
  };

  const handlePortalsPDFDocument = async (id: any, row: any) => {
    const patientId = row.id;
    setLoading(true);
    const key = await keyPromise
    try {
      const EncParams = await AesEncrypt(key, patientId);
      const response = await api.fetch("api/portals-pdfs", {
        method: "POST",
        body: JSON.stringify({ EncParams })
      });

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      // Extract filename from Content-Disposition header if available
      const contentDisposition = response.headers.get("Content-Disposition");
      let fileName = "portals-pdf"; // Default name

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="(.+)"/);
        if (match) {
          fileName = match[1];
        }
      }

      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      logOutputPatientAction(row, 'DOWNLOAD PDF', `${row.First_Name} ${row.Last_Name} portal PDF downloaded.`);
    } catch (error) {
      console.error("Error downloading patient file:", error);
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setSelectedPatientId('');
    setModalOpen(false);
    setCurrentDatePicker(currentDate);
  };  

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    if (file) {
      setSelectedFile(file);
    }
  };

  const handleUpload = async () => {
    setIsLoading(true); // Set loading state to true
    const formattedDate = currentDatePicker
      ? currentDatePicker.toLocaleDateString('en-US', {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric'
      })
      : '';
    const formData = new FormData();
    if (selectedFile) {
      formData.append('file', selectedFile);
    } else {
      // Handle the case where no file is selected
      console.error("No file selected");
      setIsLoading(false); // Set loading state to false
      return; // Early return to prevent further execution
    }
    formData.append('date', formattedDate);
    formData.append('id', selectedPatientId);
    try {
      const response = await axios.post(webservice + 'api/Patient/AudioUpload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setModalOpen(false); // Close the modal after upload
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Insurance Verification Platform",
          text: "Audio File Uploaded Successfully.",
          customClass: {
            confirmButton: "btn btn-success",
          },
          allowOutsideClick: false
        });
      }
    } catch (error) {
      console.error('Error uploading file:', error);
    } finally {
      setIsLoading(false); // Set loading state to false
    }
  };

  interface BootstrapCheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
    id: string;
  }
  // Handle individual row checkbox change
  const BootstrapCheckbox = forwardRef<HTMLInputElement, BootstrapCheckboxProps>(
    ({ id, ...props }, ref) => (
      <div style={{ position: 'relative', left: '10px' }}>
        <input type='checkbox' id={id} ref={ref} {...props} />
      </div>
    )
  );

  const handleChangecheck = useCallback(
    ({ selectedRows }: any) => {
      const selectedEventIds = selectedRows.map((row: any) => row.id);
      setEventId(selectedRows);
      setEventId1(selectedEventIds.length);
      if (!action.fromUser) return;
      selectedRowsPerPage[currentPage] = selectedRows;
    }, [currentPage, selectedRowsPerPage, action.fromUser]
  );

  const downloadRowPatientData = async (ids: any[]) => {
    try {
      // Convert the array of IDs to a JSON string
      const key = await keyPromise
      const idsString = JSON.stringify(ids);
      // Encrypt the JSON string
      const EncParams = await AesEncrypt(key, idsString);
      const response = await api.fetch('api/Patient/downloadPatientData', {
        method: 'POST',
        body: JSON.stringify({ EncParams }),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        }
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await response.json();
      const OutData = await AesDecrypt(key, responseData);
      if (!OutData.file) {
        throw new Error('No file data in response');
      }
      const zipData = Uint8Array.from(atob(OutData.file), (c) => c.charCodeAt(0));
      const blob = new Blob([zipData], { type: "application/zip" });
      const filename = "Patientdetails";
      const date = new Date();
      const day = ("0" + date.getDate()).slice(-2);
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const year = date.getFullYear();
      const formattedDate = day + month + year;
      saveAs(blob, `${filename}_${formattedDate}.zip`);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };


  const downloadRow = async (rows: PatientData[] | PatientData) => {
    if (Array.isArray(rows)) {
      setLoading(true);
      const ids = rows.map(row => row.id);
      const success = await downloadRowPatientData(ids);
      selectedRowsPerPage[currentPage] = []; // Clear selected rows for the current page
      handleChangecheck({ selectedRows: [] }); // Ensure checkboxes are unchecked
      setLoading(false);
      // Show success message
      Swal.fire({
        icon: "success",
        title: "Insurance Verification Platform",
        text: "Patient Data has been Downloaded.",
        customClass: {
          confirmButton: "btn btn-success",
        },
        allowOutsideClick: false
      }).then(() => {
        setLoading(false);
      });
    }
  };


  const downloadRowportaldata = async (ids: any[]) => {
    try {
      const key = await keyPromise
      // Convert the array of IDs to a JSON string
      const idsString = JSON.stringify(ids);
      // Encrypt the JSON string
      const EncParams = await AesEncrypt(key, idsString);
      const response = await api.fetch('api/patient/getallportalpdfs', {
        method: 'POST',
        body: JSON.stringify({ EncParams })
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await response.json();
      const OutData = await AesDecrypt(key, responseData);
      if (!OutData.file) {
        throw new Error('No file data in response');
      }
      const zipData = Uint8Array.from(atob(OutData.file), (c) => c.charCodeAt(0));
      const blob = new Blob([zipData], { type: "application/zip" });
      const filename = "Patientdetails";
      const date = new Date();
      const day = ("0" + date.getDate()).slice(-2);
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const year = date.getFullYear();
      const formattedDate = day + month + year;
      saveAs(blob, `${filename}_${formattedDate}.zip`);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  const downloadportaldataRow = async (rows: PatientData[] | PatientData) => {
    if (Array.isArray(rows)) {
      setLoading(true);
      const ids = rows.map(row => row.id);
      const pdf_status = rows.map(row => row.pdf_status);

      // Check if at least one pdf_status is "yes"
      const hasPdf = pdf_status.some(status => status === "yes");

      if (!hasPdf) {
        setLoading(false);
        Swal.fire({
          icon: "warning",
          title: "Insurance Verification Platform",
          text: "No portal PDF in the selected patients.",
          customClass: {
            confirmButton: "btn btn-warning",
          },
          allowOutsideClick: false
        });
        return;
      }

      const success = await downloadRowportaldata(ids);
      selectedRowsPerPage[currentPage] = []; // Clear selected rows for the current page
      handleChangecheck({ selectedRows: [] }); // Ensure checkboxes are unchecked
      setLoading(false);

      // Show success message
      Swal.fire({
        icon: "success",
        title: "Insurance Verification Platform",
        text: "Portal PDFs have been downloaded.",
        customClass: {
          confirmButton: "btn btn-success",
        },
        allowOutsideClick: false
      }).then(() => {
        setLoading(false);
      });
    }
  };


  const handleRegenerateDocument = async (row: any) => {
    const id = row.id
    const key = await keyPromise
    setregenrateLoading(true);
    try {
      const EncParams = await AesEncrypt(key, id);

      const fetchResponse = await api.fetch('api/Patient/regenratepatients', {
        method: 'POST',
        body: JSON.stringify({ EncParams })
      });

      const auditLogData = row.First_Name + " " + row.Last_Name + " " + "Patient have been Regenrated."


      const Username = localStorage.UserName;
      const auditData = { auditLogData, Username, Refid: id, Userid: localStorage.id, ParentUserId: localStorage.ParentUserId }
      // const auditLogResponse = await axios.post(webservice + 'api/regenrate/regenrateauditLogdata', auditData, {
      //   headers: { 'Content-type': 'application/json; charset=UTF-8' }
      // });
      const auditLogResponse = await api.fetch('api/regenrate/regenrateauditLogdata', {
        method: 'POST',
        body: JSON.stringify({ auditData })
      });

      const data = await fetchResponse.json();
      const data1 = await AesDecrypt(key, data);

      if (data1 === "S") {
        Swal.fire({
          icon: "success",
          title: "Insurance Verification Platform",
          text: "Patients have been Regenrated.",
          customClass: {
            confirmButton: "btn btn-success",
          },
          allowOutsideClick: false
        });
        handleReloadTable();
        setregenrateLoading(false);
        // navigate(`/patients`);
      }
    } catch (error) {
      console.error('Error downloading file: ', error);
    }
  };
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [patientFiles, setPatientFiles] = useState<HtmlFilePreview[]>([]);
  const [codeFiles, setCodeFiles] = useState<HtmlFilePreview[]>([]);
  const [activeTab, setActiveTab] = useState<"patient" | "code">("patient");

  const toggleModal = () => setIsOpen(!isOpen);

  // Heuristics: try several regex extraction patterns (most specific -> fallback)
  const extractionPatterns: RegExp[] = [
    /<div[^>]*ng-app=["']?providerPortal["']?[^>]*>([\s\S]*?)<\/div>/i,
    /<ui-view[^>]*>([\s\S]*?)<\/ui-view>/i,
    /<div[^>]*id=["']?main["']?[^>]*>([\s\S]*?)<\/div>/i,
    /<div[^>]*class=["'][^"']*(container|content|main)[^"']*["'][^>]*>([\s\S]*?)<\/div>/i,
    /<body[^>]*>([\s\S]*?)<\/body>/i,
  ];

  const isFullHtml = (html: string) => /<html[\s\S]*<\/html>/i.test(html);

  const extractSnippet = (html: string): string | null => {
    for (const pattern of extractionPatterns) {
      const m = html.match(pattern);
      if (m) {
        // some patterns capture in group 1, others group 1 or 2 - pick last capturing group with content
        for (let i = 1; i < m.length; i++) {
          if (m[i] && m[i].trim().length > 0) return m[i];
        }
      }
    }
    return null;
  };

  const createPreviewObject = (html: string, index: number): HtmlFilePreview => {
    const looksLikeFull = isFullHtml(html) || /<script[\s\S]*?>/i.test(html);

    // Try to extract snippet
    const snippet = extractSnippet(html);

    if (snippet && !looksLikeFull) {
      return {
        index,
        contentToInject: snippet,
        originalHtml: html,
        useIframe: false,
      };
    }

    // If snippet exists but original contains <html> or <script>, prefer iframe
    if (snippet && looksLikeFull) {
      return {
        index,
        contentToInject: snippet,
        originalHtml: html,
        useIframe: true,
      };
    }

    // If no snippet, try to fallback to body content (if any)
    const bodyMatch = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
    if (bodyMatch && bodyMatch[1] && !looksLikeFull) {
      return {
        index,
        contentToInject: bodyMatch[1],
        originalHtml: html,
        useIframe: false,
      };
    }

    // Final fallback: render inside iframe (safe)
    return {
      index,
      originalHtml: html,
      useIframe: true,
    };
  };

  const handlerawdata = async (row: any) => {
    const id = row.id;
    setIsOpen(true);
    setIsLoading(true);
    setPatientFiles([]);
    setCodeFiles([]);
    try {
      const fetchResponse = await api.fetch("api/rawdata", {
        method: "POST",
        body: JSON.stringify({ id })
      });

      if (!fetchResponse.ok) {
        const errorData = await fetchResponse.json();
        console.error("❌ Backend Error:", errorData.error);
        setIsLoading(false);
        return;
      }

      const blob = await fetchResponse.blob();
      const zip = await JSZip.loadAsync(blob);

      // Patient files (sorted)
      const patientFileNames = Object.keys(zip.files)
        .filter((filename) => filename.includes("Patient_details/") && filename.endsWith(".html"))
        .sort((a, b) => {
          const aNum = parseInt(a.match(/step_(\d+)_/)?.[1] || "0");
          const bNum = parseInt(b.match(/step_(\d+)_/)?.[1] || "0");
          return aNum - bNum;
        });

      // Code files (sorted)
      const codeFileNames = Object.keys(zip.files)
        .filter((filename) => filename.includes("code_details/") && filename.endsWith(".html"))
        .sort((a, b) => {
          const aNum = parseInt(a.match(/step_(\d+)_/)?.[1] || "0");
          const bNum = parseInt(b.match(/step_(\d+)_/)?.[1] || "0");
          return aNum - bNum;
        });

      // Load file contents (may be undefined if not found)
      const patientContentsPromises = patientFileNames.map((f) => zip.file(f)?.async("string"));
      const codeContentsPromises = codeFileNames.map((f) => zip.file(f)?.async("string"));

      const patientHtmlContents = (await Promise.all(patientContentsPromises)).filter(
        (h): h is string => !!h
      );
      const codeHtmlContents = (await Promise.all(codeContentsPromises)).filter(
        (h): h is string => !!h
      );

      // Create preview objects with heuristics
      const patientPreviews = patientHtmlContents.map((html, idx) => createPreviewObject(html, idx));
      const codePreviews = codeHtmlContents.map((html, idx) => createPreviewObject(html, idx));

      setPatientFiles(patientPreviews);
      setCodeFiles(codePreviews);

      // pick default active tab
      if (patientPreviews.length > 0) setActiveTab("patient");
      else if (codePreviews.length > 0) setActiveTab("code");
      logOutputPatientAction(row, 'DOWNLOAD RAW', `${row.First_Name} ${row.Last_Name} raw data viewed.`);
    } catch (error) {
      console.error("❌ Error fetching/unzipping:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCosting = async (row: any) => {
    // Add your costing logic here
    const id = row.id;
    try {
      const key = await keyPromise;
      const EncParams = await AesEncrypt(key, id);
      const response = await api.fetch('api/modal_details/calculate_costing', {
        method: 'POST',
        body: JSON.stringify({ EncParams })
      });
      const result = await response.json();
      const decrypted = await AesDecrypt(key, result);
      setCostingData(decrypted);
      setIsCostingModalOpen(true);
      logOutputPatientAction(row, 'VIEW COST', `${row.First_Name} ${row.Last_Name} costing details viewed.`);

    } catch (error) {
      console.error("Error fetching costing:", error);
    }
  };

  const renderPreview = (preview: HtmlFilePreview) => {
    if (preview.useIframe) {
      // iframe fallback - sandboxed view
      return (
        <div key={preview.index} style={{ margin: "10px 0", border: "1px solid #ddd" }}>
          <iframe
            title={`preview-${preview.index}`}
            srcDoc={preview.originalHtml}
            style={{ width: "100%", height: 600, border: 0 }}
            sandbox="allow-same-origin allow-scripts allow-forms"
          />
        </div>
      );
    }

    // safe injection of snippet
    return (
      <div
        key={preview.index}
        style={{ border: "1px solid #ccc", margin: "10px 0", padding: "10px", background: "#fff" }}
        dangerouslySetInnerHTML={{ __html: preview.contentToInject || "" }}
      />
    );
  };

  const handleErrorClick = async (row: any) => {
    const patientId = row.id
    setLoading(true);
    try {
      const key = await keyPromise
      const EncParams = await AesEncrypt(key, patientId);
      const response = await api.fetch("api/Email-fetchErrorDatas", {
        method: "POST",
        body: JSON.stringify({ EncParams })
      }).then((res) => res.json());
      setLoading(false);
      setIsModalOpen(true);
      setPatientData(response[0]);
    } catch (error) {
      console.error("Error fetching patient data:", error);
    } finally {
      setLoading(false); // Hide loading after fetching data
    }

  };


  // const handleRerun = async (row: any) => {
  //   if (!row || typeof row !== "object") return;
  //   try {
  //     const key = await keyPromise
  //     const EncParams = await AesEncrypt(key, row.id);
  //     const response = await fetch(webservice + "api/rerun_patient_data", {
  //       method: "POST",
  //       body: JSON.stringify({ EncParams }),
  //       headers: { "Content-Type": "application/json; charset=UTF-8" },
  //     });
  //     const data = await response.json();
  //     const decryptedData = await AesDecrypt(key, data);
  //     if (decryptedData === "Patient Re-run Successfully") {
  //       Swal.fire({
  //         icon: "success",
  //         title: "Insurance Verification Platform",
  //         text: "Patient data has been restarted successfully.",
  //         customClass: {
  //           confirmButton: "btn btn-success",
  //         },
  //         allowOutsideClick: false
  //       });
  //       handleReloadTable();
  //     }
  //   } catch (error) {
  //     console.error("Error restarting patient data:", error);
  //   }
  // };

  const CustomLoadingComponent = () => {
    return (
      <div className="">
        {store.no_Data === 'There is no Record Found' ? (
          <h4>
            <br />
            <p>There are no records to display</p>
          </h4>
        ) : (
          <div className="custom-loader">
            <label className="custom-label">Please wait...</label>
            <div className="custom-loading"></div>
          </div>
        )}
      </div>
    );
  };

  const Columns = [
    // ...(userType === "MOS"
    //   ? [
    //     {
    //       name: "",
    //       selector: () => "",
    //       width: "50px",
    //       sortable: false,
    //     },
    //     {
    //       name: "Uploaded by",
    //       selector: (row: PatientData) =>
    //         `${row.Uploaded_by} / ${row.uploaded_status}`,
    //       sortable: true,
    //       width: "150px",
    //       wrap: true, // 👈 enables text wrapping
    //     },
    //   ]
    //   : []),
    {
      id: "ClientName",
      name: "Client Name",
      selector: (row: PatientData) => row.ClientName,
      sortable: true,
      width: "150px",
      wrap: true, // 👈 text wraps
    },
    {
      id: "FirstName",
      name: "First Name",
      selector: (row: PatientData) => row.First_Name,
      sortable: true,
      width: "150px",
      wrap: true,
    },
    {
      id: "LastName",
      name: "Last Name",
      selector: (row: PatientData) => row.Last_Name,
      sortable: true,
      width: "150px",
      wrap: true,
    },
    {
      id: "DOB",
      name: "DOB",
      selector: (row: PatientData) =>
        row.Patient_DOB ? row.Patient_DOB : "N/A",
      sortable: true,
      width: "150px",
      wrap: true,
    },
    {
      id: "PayerName",
      name: "Payer Name",
      selector: (row: PatientData) => (row.payer ? row.payer : "N/A"),
      sortable: true,
      minWidth: "220px",
      cell: (row: PatientData) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {row.LogoUrl && (
            <img 
              src={row.LogoUrl} 
              alt="Logo" 
              style={{ width: '60px', height: '60px', objectFit: 'contain', marginRight: '10px' }} 
            />
          )}
          <span>{row.payer || "N/A"}</span>
        </div>
      )
    },
    {
      id: "BotStatus",
      name: "BOT Status",
      width: "150px",
      selector: (row: PatientData) => {
        if (row.Data_Fetched === "C" || row.Data_Fetched === "Completed") {
          return "Completed";
        }
        if (row.Data_Fetched === "I" || row.Data_Fetched === "In Progress") {
          return "In Progress";
        }
        if (row.Data_Fetched === "Y" || row.Data_Fetched === "Yet to Start" || row.Data_Fetched === "Yet to start") {
          return "Yet to Start";
        }
        if (row.Data_Fetched === "E" || row.Data_Fetched === "Error" || row.Data_Fetched === "Error") {
          return "Error";
        }
        return row.Data_Fetched ? row.Data_Fetched : "No";
      },
      sortable: true,
      wrap: true,
    },
    {
      id: "OutputGeneration",
      name: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <span
            id="output-generation-tooltip"
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '120px',
              cursor: 'help'
            }}
          >
            Output Generation Status
          </span>
          <UncontrolledTooltip
            placement="top"
            target="output-generation-tooltip"
            style={{ maxWidth: '300px' }}
          >
            Output Generation Status
          </UncontrolledTooltip>
        </div>
      ),
      width: "150px",
      selector: (row: PatientData) =>
        row.template_creation ? row.template_creation : "No",
      sortable: true,
      wrap: true,
    },
    {
      id: "UploadedDate",
      name: "Uploaded Date and Time",
      width: "250px",
      sortable: true,
      wrap: true,
      selector: (row: PatientData) => {
        return row.uploaded_date
          ? moment
            .utc(row.uploaded_date)
            .tz(moment.tz.guess())
            .format("MM/DD/YYYY, HH:mm:ss")
          : "NA";
      },
    },
    {
      id: "Action",
      name: "Action",
      width: "180px",
      cell: (row: PatientData) => (
        <div
          style={{ display: 'flex', alignItems: 'center', gap: 0, position: 'relative' }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Always visible: Download (direct, no sub-menu) */}
          <span style={{ width: 32, display: 'inline-flex', justifyContent: 'center', alignItems: 'center' }}>{row.Data_Fetched === 'Error' && (
            <span title="Error" style={{ cursor: 'pointer', display: 'inline-flex' }} onClick={(e) => { e.stopPropagation(); handleErrorClick(row); }}>
              <FileText size={20} color="red" />
            </span>
          )}
          {row.Data_Fetched !== 'Error' && row.template_creation === 'Completed' && (
            <>
              <Download
                className="download-icon"
                size={20}
                id={`download-${row.id}`}
                style={{ cursor: 'pointer' }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenWordDocument(row.id, row);
                }}
              />
              <UncontrolledTooltip placement="top" target={`download-${row.id}`}>Download</UncontrolledTooltip>
            </>
          )}</span>
          {/* Always visible: View Patient */}
          <span style={{ width: 32, display: 'inline-flex', justifyContent: 'center', alignItems: 'center' }}>{row.Data_Fetched !== 'Error' && row.template_creation === 'Completed' && (
            <>
              <FileText
                size={20}
                id={`view-patient-${row.id}`}
                color="#FFA500"
                style={{ cursor: 'pointer' }}
                onClick={(e) => {
                  e.stopPropagation();
                  logOutputPatientAction(row, 'VIEW', `${row.First_Name} ${row.Last_Name} patient record viewed.`);
                  navigate(`/patient-eligibility/${row.id}?view=PatientsView`);
                }}
              />
              <UncontrolledTooltip placement="top" target={`view-patient-${row.id}`}>View Patient</UncontrolledTooltip>
            </>
          )}</span>

          {/* Always visible: Audit Log (permission-gated) */}
          <span style={{ width: 32, display: 'inline-flex', justifyContent: 'center', alignItems: 'center' }}>{row.Data_Fetched !== 'Error' && row.template_creation === 'Completed' && menuActions.includes('auditlog') && (
            <>
              <Eye
                size={20}
                id={`audit-log-${row.id}`}
                color="#355876"
                style={{ cursor: 'pointer' }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleViewAuditLog(row);
                }}
              />
              <UncontrolledTooltip placement="top" target={`audit-log-${row.id}`}>Audit Log</UncontrolledTooltip>
            </>
          )}</span>

          {/* Always visible: Portal PDF */}
          <span style={{ width: 32, display: 'inline-flex', justifyContent: 'center', alignItems: 'center' }}>{row.Data_Fetched !== 'Error' && row.pdf_status === 'yes' && (
            <>

              <img
                src={pdf}
                alt="Download PDF"
                width={20}
                height={20}
                style={{ cursor: 'pointer' }}
                id={`portalpdf-${row.id}`}
                onClick={(e) => {
                  e.stopPropagation();
                  handlePortalsPDFDocument(row.id, row);
                }}
              />
              <UncontrolledTooltip placement="top" target={`portalpdf-${row.id}`}>Portal PDF</UncontrolledTooltip>
            </>
          )}</span>

          {/* Error row: show only red error icon, no three-dot menu */}
          <span style={{ width: 32, display: 'inline-flex', justifyContent: 'center', alignItems: 'center' }}>
          {row.Data_Fetched === 'Error' ? null : (
            /* Normal row: three-dot menu trigger (hover to open) */
            (row.Data_Fetched !== 'Yet to Start' &&
              row.Data_Fetched !== 'Yet to start' &&
              row.Data_Fetched !== 'Y' &&
              row.template_creation === 'Completed') ? (
              <div
                style={{ position: 'relative' }}
                onMouseEnter={() => setActionPopupRow(row.id)}
                onMouseLeave={() => setActionPopupRow(null)}
              >
                <MoreVertical
                  size={18}
                  color="#355876"
                  style={{ cursor: 'pointer' }}
                />

                {/* Popup: shown on hover */}
                {actionPopupRow === row.id && (
                  <div
                    onMouseEnter={() => setActionPopupRow(row.id)}
                    onMouseLeave={() => setActionPopupRow(null)}
                    style={{
                      position: 'absolute',
                      top: '50%',
                      right: '120%',
                      transform: 'translateY(-50%)',
                      backgroundColor: 'white',
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
                      padding: '8px 14px',
                      display: 'flex',
                      gap: '14px',
                      alignItems: 'center',
                      zIndex: 9999,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {/* Regenerate */}
                    {row.template_creation === 'Completed' && (
                      <span title="Regenerate" style={{ cursor: 'pointer', display: 'inline-flex' }} onClick={(e) => { e.stopPropagation(); setActionPopupRow(null); handleRegenerateDocument(row); }}>
                        <img src={regenrate} alt="Regenerate" width={26} height={26} />
                      </span>
                    )}

                    {/* Raw Data */}
                    {row.Data_Fetched !== 'Error' && row.template_creation === 'Completed' && (
                      <span title="Raw Data" style={{ cursor: 'pointer', display: 'inline-flex' }} onClick={(e) => { e.stopPropagation(); setActionPopupRow(null); handlerawdata(row); }}>
                        <Trello size={20} color="#f54552" />
                      </span>
                    )}

                    {/* Costing */}
                    {row.Data_Fetched !== 'Error' && row.template_creation === 'Completed' && Role === 'Dev Admin' && (
                      <span title="Costing" style={{ cursor: 'pointer', display: 'inline-flex' }} onClick={(e) => { e.stopPropagation(); setActionPopupRow(null); handleCosting(row); }}>
                        <DollarSign size={20} color="#4591f5ff" />
                      </span>
                    )}
                  </div>
                )}
              </div>
            ) : null
          )}
          </span>
        </div>
      ),
    },
  ];

  const { savedColumns, saveColumns } = useColumnPreferences('PatientsListing');
  const columnOptions: ColumnOption[] = [
    { id: 'ClientName', label: 'Client Name', locked: true },
    { id: 'FirstName', label: 'First Name' },
    { id: 'LastName', label: 'Last Name' },
    { id: 'DOB', label: 'DOB' },
    { id: 'PayerName', label: 'Payer Name' },
    { id: 'BotStatus', label: 'BOT Status' },
    { id: 'OutputGeneration', label: 'Output Generation Status' },
    { id: 'UploadedDate', label: 'Uploaded Date and Time' },
    { id: 'Action', label: 'Action', locked: true },
  ];
  const visibleColumns = Columns.filter((c) => isColVisible(columnOptions, savedColumns, c.id));

  const customStyles = {
    rows: {
      style: {
        cursor: 'pointer',
        overflow: 'visible',
        '&:hover': {
          backgroundColor: '#f0f0f0',
        },
      },
    },
    cells: {
      style: {
        overflow: 'visible',
      },
    },
    headCells: {
      style: {
        backgroundColor: '#355876',
        color: 'white',
        fontSize: '16px',
      },
    },
    expanderCell: {
      style: {
        whiteSpace: 'nowrap',
        flex: '0 0 48px',
      },
    },
    headRow: {
      style: {
        backgroundColor: '#355876',
        color: 'white',
      },
    },
  };


  const startIndex = (currentPage - 1) * rowsPerPage + 1;
  const endIndex = Math.min(currentPage * rowsPerPage, store.total);


  const handleDownload = async (id: any, fileName: string) => {
    setIsDownloading(true);
    try {
      const response = await api.fetch('api/audiodownload', {
        method: 'POST',
        body: JSON.stringify({ id })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      // Create a blob from the response
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Create a temporary anchor element to trigger the download
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName; // Use the provided filename
      document.body.appendChild(a); // Append the anchor to the document body
      a.click(); // Programmatically click the anchor to trigger the download
      a.remove(); // Remove the anchor from the document body

      // Clean up
      window.URL.revokeObjectURL(url);
      setIsDownloading(false);
    } catch (error) {
      console.error('Download failed:', error);
      setIsDownloading(false);
    }
  };

  const [isAllOpen, setIsAllOpen] = useState(false);



  const [showOptions, setShowOptions] = useState(false);

  // Constrain .page-body so table rows scroll inside instead of pushing footer off-screen
  useEffect(() => {
    const pageBody = document.querySelector<HTMLElement>('.page-body');
    if (!pageBody) return;
    const prevOverflow = pageBody.style.overflow;
    const prevMaxHeight = pageBody.style.maxHeight;
    pageBody.style.overflow = 'hidden';
    // leave room for header (~70px top margin already on .page-body) + footer (~40px)
    pageBody.style.maxHeight = 'calc(100vh - 110px)';
    return () => {
      pageBody.style.overflow = prevOverflow;
      pageBody.style.maxHeight = prevMaxHeight;
    };
  }, []);

  return (
    <>
      <Breadcrumbs mainTitle={Patients} title={Patients} />
      <Container fluid>
        <div>
          <Modal
            style={{ maxWidth: '1500px', maxHeight: '600px' }}
            isOpen={scrollInnerModal}
            toggle={() => setScrollInnerModal(!scrollInnerModal)}
            className='modal-dialog-centered modal-lg'
          >
            <ModalHeader toggle={() => setScrollInnerModal(!scrollInnerModal)}>
              Report Log
            </ModalHeader>
            <ModalBody>
              <div style={{ maxHeight: '600px', overflow: 'auto' }}>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#f2f2f2' }}>
                      <th className="audit-tableHeaderStyle">Date & Time</th>
                      <th className="audit-tableHeaderStyle">Action</th>
                      <th className="audit-tableHeaderStyle">DateWise Work Time</th>
                      <th className="audit-tableHeaderStyle">Total Work Time</th>
                      <th className="audit-tableHeaderStyle">Changed By</th>
                    </tr>
                  </thead>
                  <tbody style={{ alignItems: 'center' }}>
                    {filteredAuditData &&
                      filteredAuditData
                        .sort((a: any, b: any) => new Date(b.Modified).getTime() - new Date(a.Modified).getTime())
                        .map((item: any, index: number) => (
                          <tr key={index}>
                            <td className="audit-tableDataStyle">
                              {(() => {
                                const localDate = moment.utc(item.Modified).local().format('MM/DD/YYYY hh:mm:ss A');
                                return localDate;
                              })()}
                            </td>
                            <td className="audit-tableDataStyle">{item.Action}</td>
                            <td className="audit-tableDataStyle">
                              {item.Edit_time && typeof item.Edit_time === 'object' ? (
                                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                                  <thead>
                                    <tr style={{ backgroundColor: '#f2f2f2' }}>
                                      <th className="audit-tableHeaderStyle">Date</th>
                                      <th className="audit-tableHeaderStyle">Work Time</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {Object.entries(item.Edit_time).map(([date, time], dataIndex) => {
                                      const formattedDate = new Date(date).toLocaleDateString('en-US', {
                                        year: 'numeric',
                                        month: '2-digit',
                                        day: '2-digit'
                                      });
                                      return (
                                        <tr key={dataIndex}>
                                          <td className="audit-tableDataStyle">{formattedDate}</td>
                                          <td className="audit-tableDataStyle">
                                            {typeof time === 'string' || typeof time === 'number' ? time : 'N/A'}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              ) : (
                                'N/A'
                              )}
                            </td>
                            <td className="audit-tableDataStyle">
                              {item.Total_worktime && typeof item.Total_worktime === 'string'
                                ? item.Total_worktime
                                : 'N/A'}
                            </td>
                            <td className="audit-tableDataStyle">
                              {item.UserName && Array.isArray(item.UserName)
                                ? item.UserName.join(', ')
                                : item.UserName}
                            </td>
                          </tr>
                        ))}
                  </tbody>
                </table>
              </div>
            </ModalBody>
          </Modal>
        </div>
        {/* --- MODIFIED MODAL START --- */}
        <div>
          <Modal isOpen={isOpen} toggle={toggleModal} size="xl">
            <ModalHeader toggle={toggleModal}>Raw Data Viewer</ModalHeader>
            <ModalBody style={{ maxHeight: "75vh", overflowY: "auto" }}>
              {isLoading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ padding: 40 }}>
                  <Spinner /> <span className="ms-2">Loading...</span>
                </div>
              ) : (
                <>
                  <Nav tabs>
                    {patientFiles.length > 0 && (
                      <NavItem>
                        <NavLink
                          className={activeTab === "patient" ? "active" : ""}
                          onClick={() => setActiveTab("patient")}
                          style={{ cursor: "pointer" }}
                        >
                          Patient Details ({patientFiles.length})
                        </NavLink>
                      </NavItem>
                    )}
                    {codeFiles.length > 0 && (
                      <NavItem>
                        <NavLink
                          className={activeTab === "code" ? "active" : ""}
                          onClick={() => setActiveTab("code")}
                          style={{ cursor: "pointer" }}
                        >
                          Code Details ({codeFiles.length})
                        </NavLink>
                      </NavItem>
                    )}
                  </Nav>

                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="patient">
                      {patientFiles.length === 0 ? (
                        <div style={{ padding: 20 }}>No patient files found.</div>
                      ) : (
                        patientFiles.map((p) => renderPreview(p))
                      )}
                    </TabPane>

                    <TabPane tabId="code">
                      {codeFiles.length === 0 ? (
                        <div style={{ padding: 20 }}>No code files found.</div>
                      ) : (
                        codeFiles.map((c) => renderPreview(c))
                      )}
                    </TabPane>
                  </TabContent>
                </>
              )}
            </ModalBody>
          </Modal>

        </div>
        {/* --- MODIFIED MODAL END --- */}

        {/* Summary stat cards */}
        <Row className="mb-3">
          {[
            { label: 'Total', value: statusCounts.total, icon: <Users size={28} color="#355876" />, bg: '#eaf1fb', border: '#355876' },
            { label: 'Completed', value: statusCounts.completed, icon: <CheckCircle size={28} color="#0f7b4e" />, bg: '#e6f7f1', border: '#0f7b4e' },
            { label: 'In Progress', value: statusCounts.inProgress, icon: <Clock size={28} color="#b8860b" />, bg: '#fff8e6', border: '#b8860b' },
            { label: 'Failed', value: statusCounts.failed, icon: <XCircle size={28} color="#c0392b" />, bg: '#fdecea', border: '#c0392b' },
          ].map((stat) => (
            <Col sm={6} md={3} key={stat.label}>
              <div style={{
                display: 'flex', alignItems: 'center', gap: '16px',
                background: 'white', border: `1.5px solid #e8e8e8`,
                borderLeft: `4px solid ${stat.border}`,
                borderRadius: '10px', padding: '16px 20px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
              }}>
                <div style={{ background: stat.bg, borderRadius: '50%', width: 52, height: 52, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  {stat.icon}
                </div>
                <div>
                  <div style={{ fontSize: 24, fontWeight: 700, color: '#222', lineHeight: 1 }}>{stat.value.toLocaleString()}</div>
                  <div style={{ fontSize: 13, color: '#666', marginTop: 4 }}>{stat.label}</div>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        <Row>
          <Col sm={12}>
            <div style={{ position: 'relative' }}>
              <div>
                <Card >
                  <CardBody>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div style={{ flex: 1, minHeight: 0 }}>
                        <DataTable
                          fixedHeader
                          fixedHeaderScrollHeight="calc(100vh - 420px)"
                          responsive
                          persistTableHead
                          subHeader={true}
                          onSort={handleSort}
                          data={dataToRender()}
                          columns={visibleColumns}
                          paginationServer
                          customStyles={customStyles}
                          paginationPerPage={rowsPerPage}
                          paginationDefaultPage={currentPage}
                          onRowClicked={handleRowClick}
                          pointerOnHover
                          conditionalRowStyles={[{
                            when: (row: PatientData) => selectedPatient?.id === row.id,
                            style: { backgroundColor: '#e8f4fd', borderLeft: '3px solid #355876' },
                          }]}
                          selectableRows
                          selectableRowsHighlight
                          selectableRowsComponent={BootstrapCheckbox as unknown as React.ReactNode}
                          onSelectedRowsChange={handleChangecheck}
                          paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                          clearSelectedRows={loading}
                          noDataComponent={<CustomLoadingComponent />}
                          paginationComponent={CustomPagination}
                          subHeaderComponent={
                            <CustomHeader
                              value={value}
                              menuActions={menuActions}
                              rowsPerPage={rowsPerPage}
                              handleFilter={handleFilter}
                              handlePerPage={handlePerPage}
                              insuranceData={insuranceOption}
                              selectedInsurance={insurance}
                              handleInsuranceChange={handleInsuranceChange}
                              botStatusOptions={botStatusOptions}
                              selectedBotStatus={selectedBotStatus}
                              handleBotStatusChange={handleBotStatusChange}
                              startDate={startDate}
                              endDate={endDate}
                              handleStartDateChange={handleStartDateChange}
                              handleEndDateChange={handleEndDateChange}
                              onAddClick={() => navigate("/BulkUpload")}
                              showFilters={showFilters}
                              setShowFilters={setShowFilters}
                              columnOptions={columnOptions}
                              savedColumns={savedColumns}
                              onColumnsChange={saveColumns}
                            />
                          }


                        />
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div style={{ paddingLeft: '2%' }}>
                            {store.total && (
                              <span><strong>{`${startIndex} to ${endIndex} of ${store.total} entries`}</strong></span>
                            )}
                          </div>
                          <div>
                            <CustomPagination />
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
                <div>
                  {eventId1 > 0 && menuActions.includes('delete') && (
                    <div className="customizer-links open">
                      <Nav className="flex-column nav-pills">
                        <a className="nav-link" onClick={() => DeleteRow(eventId)}>
                          <span>Delete</span>
                          <Trash2 className="trash-icon" size={20} />
                        </a>
                      </Nav>
                    </div>
                  )}
                  {eventId.length > 1 && (
                    <div className="customizer1-links open" onMouseEnter={() => setShowOptions(true)}
                      onMouseLeave={() => setShowOptions(false)}>
                      <Nav className="flex-column nav-pills">
                        <div
                          className="nav-link download-container"

                        >
                          <Download className="download-icon" size={20} />
                          {showOptions && (
                            <div className="dropdown-options">
                              <a onClick={() => downloadRow(eventId)}>Download Patient Output</a>
                              <a onClick={() => downloadportaldataRow(eventId)}>Download Portal PDF</a>
                            </div>
                          )}
                        </div>
                      </Nav>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      {/* Fixed overlay panel */}
      {selectedPatient && (
        <SelectedPatientPanel
          patient={selectedPatient}
          onClose={() => setSelectedPatient(null)}
          onOpenDetail={(row) => navigate(`/patient-eligibility/${row.id}?view=PatientsView`)}
          onDownloadPDF={handleOpenPDFDocument}
          onEditPatient={(row) => navigate(`/patient-eligibility/${row.id}?view=PatientsView&edit=true`)}
        />
      )}
      {loading && (
        <div >
          <div className="loading-overlay">
            <div id="page">
              <div id="container">
                <div id="ring"></div>
                <div id="ring"></div>
                <div id="ring"></div>
                <div id="ring"></div>
                <div id="h3" style={{ color: "#212529", fontSize: "16px", fontWeight: "bold", textAlign: "center", marginTop: "20px" }}>
                  Downloading...
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {regenrateLoading && (
        <div >
          <div className="loading-overlay">
            <div id="page">
              <div id="container">
                <div id="ring"></div>
                <div id="ring"></div>
                <div id="ring"></div>
                <div id="ring"></div>
                <div id="h3" style={{ color: "black" }}>Regenrating...</div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Modal isOpen={modalOpen} toggle={closeModal}>
        <ModalHeader toggle={closeModal}><h3>Upload Audio Files</h3></ModalHeader>
        <ModalBody>
          <Label check>Date of Call Recording: </Label>&nbsp;&nbsp;&nbsp;
          <ReactDatePicker
            id="end-date-picker"
            className="form-control"
            selected={currentDatePicker}
            onChange={(date: Date | null) => setCurrentDatePicker(date)}
            dateFormat="MM-dd-yyyy"
            isClearable
          />
          <br />
          <br />
          <input type="file" accept="audio/*" onChange={handleFileChange} ref={fileInputRef} />
          {/* List of files with download buttons */}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={closeModal}>Cancel</Button>
          <Button color="primary" onClick={handleUpload}>
            {isLoading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : 'Upload'}
          </Button>
          <br />
          <br />
          <div className="audio-files-container">
            <h3>Uploaded Audio Files</h3>
            <br />
            {audioFiles.map((file, index) => (
              <div key={index} className="audio-file-item">
                <span className="audio-file-name">{file.fileName}</span>
                {isDownloading ? (
                  <div className="spinner"></div>
                ) : (
                  <Download onClick={() => handleDownload(file.id, file.fileName)} style={{ cursor: 'pointer' }} />
                )}
              </div>
            ))}
          </div>
        </ModalFooter>
      </Modal>

      <Modal isOpen={isCostingModalOpen} toggle={() => setIsCostingModalOpen(false)} centered>
        <ModalHeader toggle={() => setIsCostingModalOpen(false)}>Costing</ModalHeader>
        <ModalBody>
          {costingData?.success ? (
            <>
              <div className="table-responsive">
                <table className="table table-bordered mb-3">
                  <thead>
                    <tr>
                      <th>Cost Type</th>
                      <th className="text-end">Cost</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Flash Input</td>
                      <td className="text-end">{Number(costingData?.cost_breakdown?.flash_input_cost ?? 0).toFixed(6)}</td>
                    </tr>
                    <tr>
                      <td>Flash Output</td>
                      <td className="text-end">{Number(costingData?.cost_breakdown?.flash_output_cost ?? 0).toFixed(6)}</td>
                    </tr>
                    <tr>
                      <td>Flash Thought</td>
                      <td className="text-end">{Number(costingData?.cost_breakdown?.flash_thought_cost ?? 0).toFixed(6)}</td>
                    </tr>
                    <tr>
                      <td>Pro Input</td>
                      <td className="text-end">{Number(costingData?.cost_breakdown?.pro_input_cost ?? 0).toFixed(6)}</td>
                    </tr>
                    <tr>
                      <td>Pro Output</td>
                      <td className="text-end">{Number(costingData?.cost_breakdown?.pro_output_cost ?? 0).toFixed(6)}</td>
                    </tr>
                    <tr>
                      <td>Pro Thought</td>
                      <td className="text-end">{Number(costingData?.cost_breakdown?.pro_thought_cost ?? 0).toFixed(6)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <strong>Total Cost</strong>
                <strong>{Number(costingData?.total_cost ?? 0).toFixed(6)}</strong>
              </div>
            </>
          ) : (
            <div>Costing data not available.</div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setIsCostingModalOpen(false)}>Close</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={auditLogModalOpen} toggle={() => setAuditLogModalOpen(false)} size="xl" scrollable>
        <ModalHeader toggle={() => setAuditLogModalOpen(false)}>Audit Log - {auditLogPatientName}</ModalHeader>
        <ModalBody>
          {auditLogLoading ? (
            <div className="text-center"><Spinner color="primary" /></div>
          ) : auditLogEntries.length > 0 ? (
            <Table bordered size="sm">
              <thead>
                <tr>
                  <th>Action</th>
                  <th>Modified</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {auditLogEntries.map((entry, index) => (
                  <tr key={index}>
                    <td>{entry.Action}</td>
                    <td>{entry.Modified}</td>
                    <td>{renderJsonDataTable(entry.JsonData, entry.Action, entry.Parentid)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <div className="text-center">No audit records found for this patient.</div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setAuditLogModalOpen(false)}>Close</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={isModalOpen} toggle={() => setIsModalOpen(false)} size="xl" centered>
        <ModalBody style={{ textAlign: "center", padding: "20px", maxHeight: "90vh", overflowY: "auto" }}>
          {viewingImage ? (
            // Full-screen image view
            <>
              <img
                src={`data:image/jpeg;base64,${patientData.image_base64}`}
                alt="Full Screen View"
                style={{
                  width: "100%",
                  height: "90vh",
                  objectFit: "contain",
                  borderRadius: "8px",
                }}
              />
              <button
                onClick={() => setViewingImage(false)}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  background: "red",
                  color: "white",
                  border: "none",
                  padding: "8px 12px",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "16px",
                }}
              >
                ✕ Close
              </button>
            </>
          ) : loading ? (
            <p style={{ color: "black" }}>Loading data...</p>
          ) : patientData ? (
            // Main error details view
            <div className="email-wrapper" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <p>{patientData.Payer_name}</p>
              <h3>Error: {patientData.error_message}</h3>
              <p>
                Location:{" "}
                <a href={patientData.error_page_url} target="_blank" rel="noopener noreferrer">
                  {patientData.error_page_url}
                </a>
              </p>

              {patientData.image_base64 ? (
                <div style={{ marginTop: "15px" }}>
                  <img
                    src={`data:image/jpeg;base64,${patientData.image_base64}`}
                    alt="Error Screenshot"
                    style={{
                      width: "100%",
                      maxWidth: "500px",
                      borderRadius: "8px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      const imageUrl = `data:image/jpeg;base64,${patientData.image_base64}`;
                      const newWindow = window.open();
                      if (newWindow) {
                        newWindow.document.write(
                          `<img src="${imageUrl}" style="width:100%;height:auto;object-fit:contain;" />`
                        );
                      }
                    }}
                  />

                </div>
              ) : (
                <p>No image available</p>
              )}
            </div>
          ) : (
            <p>Please select a ticket to view details.</p>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default Patient;
